import { Box, IconButton, Typography } from '@mui/material';
import { LocationDetailsModalTexts } from './texts';
import { LocationDetailsModalSx } from './styles';
import { SettingModalCss } from 'src/content/keywordResearch/keywordTracking/KeywordTrackingAllCss';
import { viewScanDialogSx } from 'src/common/ViewScanDialogSxs';
import CloseIcon from '@mui/icons-material/Close';
import Loader from 'src/common/config/Loader';
import { lazy } from 'react';
const AddLocationForm = Loader(
  lazy(() =>
    import('./AddLocationForm').then((module) => ({
      default: module.AddLocationForm
    }))
  )
);
import { isLocalSeoUser } from 'src/common/config/FunctionHelper';

export const AddLocationDetailsModal = ({
  handleClose,
  isNotModal = null,
  setTabIndex = (value: any) => {},
  setDetailModalPayload = (value: any) => {},
  callCreateLocation = (value: any) => {},
  scanForCitations = (value: any) => {}
}) => {
  const isLocalSeo = isLocalSeoUser();
  return (
    <>
      <Box padding={4}>
        <Box sx={SettingModalCss?.titleBoxSx}>
          <Typography sx={LocationDetailsModalSx?.title}>
            {isNotModal
              ? LocationDetailsModalTexts?.noModalTitle
              : LocationDetailsModalTexts?.title}
          </Typography>
          {!isNotModal && (
            <IconButton
              aria-label="close"
              style={{
                marginTop: '-12px',
                ...viewScanDialogSx?.closeIconBtnSx
              }}
              className="hover:rounded-lg"
              onClick={handleClose}
            >
              <CloseIcon sx={{ color: 'var(--color-text-sidebar-icon)' }} />
            </IconButton>
          )}
        </Box>
        <Typography sx={LocationDetailsModalSx?.desc}>
          {isLocalSeo
            ? LocationDetailsModalTexts.descLocalSeoPart1
            : LocationDetailsModalTexts.descPart1}{' '}
          <Box component="span" fontWeight={600}>
            {LocationDetailsModalTexts.descBold}
          </Box>{' '}
        </Typography>

        <AddLocationForm
          handleClose={handleClose}
          setTabIndex={setTabIndex}
          isNotModal={isNotModal}
          setDetailModalPayload={setDetailModalPayload}
          callCreateLocation={callCreateLocation}
          scanForCitations={scanForCitations}
        />
      </Box>
    </>
  );
};
